export default "__VITE_ASSET__b933a5c1__"